/**
 * Request to reverse geocode a position
 * @param {Object} position - Position object returned from `navigator.geolocation`
 * @return {Promise} - Fetch promise, evenutally returns a response from HERE Reverse Geocoder API
 */
export function reverseGeocode(position) {
  const coords = position.coords.latitude + "," + position.coords.longitude;

  // for testing specific locations
  // const coords = "32.220290,-110.968488"; // Tucson

  // This endpoint is proxied
  const api = `/here-api/${navigator.language}/${coords}`;

  return fetch(api)
    .then(response => response.json())
    .catch(error => {
      console.log(error);
    });
}

/**
 * Error callback for navigator.geolocation
 * @param {Object} error - `PositionError` object
 * @return {Object} - `Object` that contains the relevant error emoji and message
 */
export function error(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return {
        emoji: "😔",
        message: "Location services must be enabled for this app to work."
      };
    case error.POSITION_UNAVAILABLE:
      return {
        emoji: "🤔",
        message:
          "We were unable to determine your position. Please try again in a bit."
      };
    case error.TIMEOUT:
      return {
        emoji: "😖",
        message: "This is taking too long. Please try again in a bit."
      };
    default:
      return {
        emoji: "😳",
        message:
          "Well this is embarrassing. We are not sure what happened. Please try again in a bit."
      };
  }
}

/**
 * Options for `navigator.geolocation`
 * @return {Object} - Contains `maximumAge`, `timeout`, and `enableHighAccuracy`
 */
export function options() {
  return { maximumAge: 0, timeout: 5000, enableHighAccuracy: true };
}
